import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';
import { getBreakpointFromManor } from 'ctm-components';

import { ProceedWithProvider } from '../../products/products/common/proceed_with_provider';
import { ProviderLogo } from '../../products/products/common/provider_logo';
import { ProductPrice } from '../../products/products/common/product_price';
import { withQuoteFlatten } from '../../products/products/common/with_quote_flatten';

const useStyles = createUseStyles((theme) => ({
    priceHeaderContainer: {
        backgroundColor: theme.colors.primary50,
        extend: ({ breakpoint }) => {
            if (breakpoint === 'xs') {
                return {
                    display: 'block',
                    paddingTop: theme.spacing['12'],
                    paddingLeft: theme.spacing['24'],
                    paddingRight: theme.spacing['24'],
                    paddingBottom: theme.spacing['12']
                };
            }
            return {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                paddingTop: theme.spacing['32'],
                paddingLeft: theme.spacing['40'],
                paddingRight: theme.spacing['40'],
                paddingBottom: theme.spacing['16']
            };
        }
    },
    logoContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        extend: ({ breakpoint }) => {
            if (breakpoint === 'xs') {
                return {
                    justifyContent: 'space-between',
                    marginBottom: theme.spacing['8']
                };
            }
            return {
                justifyContent: 'none',
                marginBottom: 0
            };
        }
    },
    buttonContainer: ({ breakpoint }) => breakpoint === 'sm' && {
        width: '30.8rem'
    },
    priceNumber: {
        fontSize: theme.fontSize['4xl']
    }
}));

// as per designs, we are only using this component on breakpoint xs and sm
const _PriceHeader = ({ quote, providerCode, productAnnualPremium, productMonthlyPremium }) => {
    const breakpoint = getBreakpointFromManor();
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme, breakpoint });
    return (
        <div className={classes.priceHeaderContainer}>
            <div className={classes.logoContainer}>
                <ProviderLogo code={providerCode} />
                <ProductPrice
                    productAnnualPremium={productAnnualPremium}
                    productMonthlyPremium={productMonthlyPremium}
                    priceDollarsClassName={classes.priceNumber}
                    priceCentsClassName={classes.priceNumber}
                />
            </div>
            <div className={classes.buttonContainer}>
                <ProceedWithProvider quote={quote} currentIndex={0} />
            </div>
        </div>
    );
};

_PriceHeader.propTypes = {
    quote: PropTypes.object.isRequired,
    // destruct from quote
    providerCode: PropTypes.string.isRequired,
    productAnnualPremium: PropTypes.number.isRequired,
    productMonthlyPremium: PropTypes.number.isRequired
};

const PriceHeader = withQuoteFlatten(_PriceHeader);

export { PriceHeader };
